import type { usePlan } from "@/features/auth";
import type { NotificationTypeConfig } from "@/features/notifications/types/notifications.type";

export const NOTIFICATION_CONFIGS: NotificationTypeConfig[] = [
  {
    key: "exchanges",
    label: "Discussions",
    route: "/discussions",
  },
  {
    key: "channels",
    label: "Messages",
    route: "/chat",
  },
  {
    key: "lottery_prizes",
    label: "Tombola",
    route: "/raffles",
  },
];

export const hasFeatureAccess = (
  key: NotificationTypeConfig["key"],
  plan: ReturnType<typeof usePlan>,
): boolean => {
  if (!plan) return false;

  switch (key) {
    case "exchanges":
      return plan.features.service_exchanges;
    case "channels":
      return plan.features.service_chat || plan.features.service_chat_legacy;
    case "lottery_prizes":
      return plan.features.service_lottery;
    default:
      return false;
  }
};
